import { useState } from "react";
import { MdKeyboardArrowDown } from "react-icons/md";
import { MdKeyboardArrowUp } from "react-icons/md";

const RacingSport = () => {
  const [isOpen, setOpen] = useState(false);

  return (
    <>
      <div className="bg-[#0088CC] text-white pt">
        <li
          className="flex items-center justify-between cursor-pointer"
          onClick={() => setOpen(!isOpen)}
        >
          <span className="font-semibold h-[30px] cursor-pointer">Racing Sports </span>
          {isOpen ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}
        </li>
        
      </div>
      {isOpen && (
          <ul className="bg-[#bbbbbb] transition-all duration-75">
            <li className="border-b-1 border-gray-500 h-[30px] pt">Horse Racing</li>
            <li className=" h-[30px] pt">Greyhound Racing</li>
          </ul>
        )}
    </>
  );
};

export default RacingSport;
